import script from "./ProxyListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyListModal.vue?vue&type=script&setup=true&lang=js"

import "./ProxyListModal.vue?vue&type=style&index=0&id=8d3861de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d3861de"]])

export default __exports__